import React from 'react';
import Datatable from '../../../../../../components/molecules/datatable';
import { TableColumns } from './configuration';

interface IProps {
  data: any;
}
export default function DatatableList(props: IProps) {
  return (
    <Datatable
      loading={true}
      data={props.data || []}
      columns={TableColumns()}
    />
  );
}
